import type { FunctionComponent } from "react";
import { ShareMetricsCommonPartial } from "../../../partials/common/share-metrics/share-metrics.common.partials";

export const ShareMetricsCommonScreen: FunctionComponent = () => {
	return <ShareMetricsCommonPartial />;
};
